module.exports = __webpack_public_path__ + "img/1557614062518476802.4961e0a9.png";